module.exports = __webpack_public_path__ + "img/huanyuanpingmudaxiao.92ffc136.png";